import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { IoIosArrowBack } from "react-icons/io";
import { Form } from "react-bootstrap";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";
import { Controller, useForm } from "react-hook-form";
import { t } from "i18next";
import { isEmpty } from "lodash";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Auth = () => {
  const setUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.setUser;
  });
  const loginUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.loginUser;
  });
    const rememberMe = useContextSelector(AuthContext, (ctx) => {
    return ctx.rememberMe;
  });
   const setRememberMe = useContextSelector(AuthContext, (ctx) => {
    return ctx.setRememberMe;
  });
  
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const { type } = useParams();
  const [showPassword, setShowPassword] = useState(true);
  const [showPassword2, setShowPassword2] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const handleShow2 = () => {
    setShowPassword2(!showPassword2);
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    const savedPassword = localStorage.getItem("password");

    if (savedUsername) {
      setValue("username", savedUsername);
    }

    if (savedPassword) {
      setValue("password", savedPassword);
    }
  }, [setValue]);

  const onSubmit = (data) => {
    loginUser(data);
  };
  const onSubmitRegister = async (body) => {
    localStorage.clear();
    try {
      const { status, data: response_users1 } = await apiPost(
        apiPath.registerUser,
        {
          username: body?.username,
          password: body?.password,
          uniqueId: Math.random() * 10000,
          refreralCode: body?.refreralCode || "",
          phone_number:
            inputRef?.current?.state.selectedCountry?.countryCode +
            body?.mobile?.substring(
              inputRef?.current?.state.selectedCountry?.countryCode?.length,
              body?.mobile?.toString()?.length,
            ),
        },
      );
      if (status === 200) {
        if (response_users1.success) {
          localStorage.setItem("token", response_users1?.results?.token);
          localStorage.setItem(
            "refresh_token",
            response_users1?.results?.refresh_token,
          );
          setUser(jwt_decode(response_users1?.results.token));
          navigate("/");
          window.location.reload();
        } else {
          toast.error(response_users1?.message);
        }
      } else {
        toast.error(response_users1?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };
  const [captcha, setCaptcha] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const generateCaptcha = () => {
    const random = Math.floor(1000 + Math.random() * 9000).toString(); // 4 digits
    setCaptcha(random);

    const canvas = document.createElement("canvas");
    canvas.width = 100;
    canvas.height = 40;

    const ctx = canvas.getContext("2d");

    // Background
    ctx.fillStyle = "#f2f2f2";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Text style
    ctx.font = "26px Arial";
    ctx.fillStyle = "#000";
    ctx.textBaseline = "middle";
    ctx.fillText(random, 20, 20);

    // Add random noise lines
    for (let i = 0; i < 4; i++) {
      ctx.strokeStyle = "rgba(0,0,0,0.2)";
      ctx.beginPath();
      ctx.moveTo(Math.random() * 100, Math.random() * 40);
      ctx.lineTo(Math.random() * 100, Math.random() * 40);
      ctx.stroke();
    }

    setImageUrl(canvas.toDataURL("image/png")); // Convert to base64
  };
  useEffect(() => {
    generateCaptcha();
  }, []);
  const { search } = useLocation();
  let code = search?.split("=")[1];
  let codeCondition = search?.split("=")?.includes("?referral_code")
    ? true
    : false;

  useEffect(() => {
    if (codeCondition) {
      setValue("refreralCode", code);
    }
  }, [code, codeCondition]);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="_container_box">
        <div className="login_wrap">
          <div id="this_home_bg" className="form" />
          <div onClick={() => navigate("/")} className="btn-goback">
            <IoIosArrowBack color="white" />
          </div>
          <div className="form_logo">
            <img
              onClick={() => navigate("/")}
              src="/assets/chorki/logo.svg"
              alt
            />
          </div>
          <div className="form_wrap">
            <Form
              onSubmit={handleSubmit(
                type == "login" ? onSubmit : onSubmitRegister,
              )}
              className="form_inputs login_height"
              // autoComplete="off"
            >
              <div className="outter_form login_form">
                <div
                  className={
                    type == "login" ? "login-form-bg" : "register-form-bg"
                  }
                >
                  <div className="form_header">
                    <div className="form_title">
                      {type == "login" ? "Log In" : "Register"}
                    </div>
                    <div className="page-switch-wrap">
                      <Link
                        className={`page-switch-btn ${
                          type == "login" ? "on" : ""
                        } `}
                        to="/auth/login"
                      >
                        {t("LogIn")}
                      </Link>
                      <Link
                        className={`page-switch-btn ${
                          type == "register" ? "on" : ""
                        } `}
                        to="/auth/register"
                      >
                        {t("Register")}
                      </Link>
                    </div>
                  </div>
                  {type == "login" && (
                    <>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <input
                            type="text"
                            className="form-control username  form_success"
                            name="username"
                            // autoComplete="off"
                            placeholder={t("Username")}
                            {...register("username", {
                              required: t("Enter_Username"),
                            })}
                          />
                          {!isEmpty(errors.username) &&
                            !isEmpty(errors.username.message) && (
                              <div className="panel panel-default">
                                <strong className="on">
                                  {errors.username?.message}
                                </strong>
                              </div>
                            )}
                        </div>
                      </div>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <input
                            type={showPassword ? "text" : "password"}
                            // autoComplete="new-password"
                            className="form-control password form_success"
                            name="password"
                            placeholder={t("Password")}
                            {...register("password", {
                              required: t("Enter_Password"),
                              minLength: {
                                value: 6,
                                message: t("PasswordMin"),
                              },
                              maxLength: {
                                value: 20,
                                message: t("PasswordMax"),
                              },
                            })}
                          />
                          <span className="input-icon">
                            <svg className="am-icon am-icon-icon-password_df9b0794 am-icon-md">
                              <use xlinkHref="#icon-password_df9b0794" />
                            </svg>
                          </span>
                          <span
                            onClick={() => handleShow()}
                            className="hide_pass"
                          >
                            {showPassword ? <FaEyeSlash /> : <FaRegEye />}
                          </span>
                          {!isEmpty(errors.password) &&
                            !isEmpty(errors.password.message) && (
                              <div className="panel panel-default">
                                <strong className="on">
                                  {errors.password?.message}
                                </strong>
                              </div>
                            )}
                        </div>
                      </div>{" "}
                    </>
                  )}
                  {type == "register" && (
                    <>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <span className="input_required">*</span>
                          <input
                            type="text"
                            // autoComplete="off"
                            placeholder={t("Username")}
                            className="form-control username form_success"
                            name="username"
                            {...register("username", {
                              required: false,
                              minLength: {
                                value: 3,
                                message: t("Min3User"),
                              },
                              maxLength: {
                                value: 30,
                                message: t("Max30User"),
                              },
                              // pattern: {
                              //   value: /^[a-zA-Z ]*$/,
                              //   message: t("Enter_Valid_Username"),
                              // },
                            })}
                          />
                          <span className="input-icon">
                            <svg className="am-icon am-icon-icon-username_e61fd380 am-icon-md">
                              <use xlinkHref="#icon-username_e61fd380" />
                            </svg>
                          </span>
                          {!isEmpty(errors?.username?.message) && (
                            <div className="panel panel-default">
                              <strong className="on">
                                {errors?.username?.message}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <span className="input_required">*</span>
                          <input
                            type={!showPassword ? "text" : "password"}
                            // autoComplete="off"
                            placeholder={t("Password")}
                            className="form-control  form_success"
                            name="password"
                            {...register("password", {
                              required: t("Enter_Password"),
                              minLength: {
                                value: 6,
                                message: t("PasswordMin"),
                              },
                              maxLength: {
                                value: 20,
                                message: t("PasswordMax"),
                              },
                            })}
                          />
                          <span className="input-icon">
                            <svg className="am-icon am-icon-icon-password_df9b0794 am-icon-md">
                              <use xlinkHref="#icon-password_df9b0794" />
                            </svg>
                          </span>
                          <span
                            onClick={() => handleShow()}
                            className="hide_pass"
                          >
                            {showPassword ? <FaEyeSlash /> : <FaRegEye />}
                          </span>
                          {!isEmpty(errors?.password?.message) && (
                            <div className="panel panel-default">
                              <strong className="on">
                                {errors?.password?.message}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <span className="input_required">*</span>
                          <input
                            type={!showPassword2 ? "text" : "password"}
                            className="form-control  undefined"
                            // autoComplete="off"
                            name="confimpsw"
                            placeholder={t("Confirm_Password")}
                            {...register("confirmpassword", {
                              required: t("Enter_CPassword"),
                              validate: (value) => {
                                if (!isEmpty(watch("password"))) {
                                  if (value == watch("password")) {
                                    return true;
                                  } else {
                                    return t("PasswordMatch");
                                  }
                                }
                              },
                            })}
                          />
                          <span
                            onClick={() => handleShow2()}
                            className="hide_pass"
                          >
                            {showPassword2 ? <FaEyeSlash /> : <FaRegEye />}
                          </span>
                          {!isEmpty(errors?.confirmpassword?.message) && (
                            <div className="panel panel-default">
                              <strong className="on">
                                {errors?.confirmpassword?.message}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-group phone-number ng-star-inserted form-group">
                        <div className="input-wrap phone-wrap fixed_list">
                          <span className="input_required">*</span>

                          <Controller
                            control={control}
                            name="mobile"
                            rules={{
                              required: t("Enter_Mobile"),
                              validate: (value) => {
                                let inputValue = value
                                  ?.toString()
                                  ?.slice(
                                    inputRef?.current?.state?.selectedCountry
                                      ?.countryCode?.length,
                                    value?.length,
                                  );
                                if (inputValue?.length < 10) {
                                  return t("MobileMin");
                                } else if (inputValue?.length > 12) {
                                  return t("MobileMax");
                                } else {
                                  return true;
                                }
                              },
                            }}
                            render={({ field: { ref, ...field } }) => (
                              <>
                                <PhoneInput
                                  {...field}
                                  inputExtraProps={{
                                    ref,
                                    required: true,
                                    autoFocus: true,
                                  }}
                                  ref={inputRef}
                                  className="inputrefNew"
                                  placeholder="Mobile Number"
                                  country={"bd"}
                                  disableDropdown={true}
                                  countryCodeEditable={false}
                                />
                              </>
                            )}
                          />
                        </div>

                        {!isEmpty(errors?.mobile?.message) && (
                          <div className="panel panel-default">
                            <strong className="on">
                              {errors?.mobile?.message}
                            </strong>
                          </div>
                        )}
                      </div>
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <span className="input_required">*</span>
                          <input
                            type="text"
                            // autoComplete="off"
                            placeholder={t("Entercaptcha")}
                            className="form-control captcha"
                            name="identifying"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            {...register("validateCode", {
                              required: t("Enter_Vadlidation"),
                              validate: {
                                validate: (value) =>
                                  parseInt(value) === parseInt(captcha) ||
                                  t("Invalidvalidatecode"),
                              },
                            })}
                          />

                          <img
                            onClick={() => generateCaptcha()}
                            src={imageUrl}
                            alt="captcha"
                            className="catchat_pic"
                          />
                          <span className="input-icon">
                            <svg className="am-icon am-icon-icon-captcha_d8d2e074 am-icon-md">
                              <use xlinkHref="#icon-captcha_d8d2e074" />
                            </svg>
                          </span>
                          {!isEmpty(errors?.validateCode?.message) && (
                            <div className="panel panel-default">
                              <strong className="on">
                                {errors?.validateCode?.message}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>{" "}
                      <div
                        style={{ marginBottom: "15px" }}
                        className="form-group"
                      >
                        <div className="fixed_list">
                          <input
                            type="text"
                            // autoComplete="off"
                            placeholder={t("Referral")}
                            className="form-control username form_success"
                            {...register("refreralCode")}
                          />
                          <span className="input-icon">
                            <svg className="am-icon am-icon-icon-username_e61fd380 am-icon-md">
                              <use xlinkHref="#icon-username_e61fd380" />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                  {type == "login" && (
                    <div className="checkbox-container">
                      <div
                        className={`sm-checkbox-item  ${rememberMe ? "sm-checkbox-item-select" : ""
                          }`}
                        onClick={() => setRememberMe(!rememberMe)}
                      >
                        <i className="sm-checkbox-item-bg" />

                        <span className="sm-label">
                          {t("Remember")}
                        </span>
                      </div>
                      <Link className="form_link forget" to="/forget">
                        {t("ForgotPassword")}
                      </Link>
                    </div>
                  )}

                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className="disclaimer-check"
                  >
                    <div className="sm-checkbox-item sm-checkbox-item-select">
                      <i className="sm-checkbox-item-bg" />
                      <span className="sm-label" />
                    </div>
                    <div style={{ color: "white" }} className="term-tips">
                      <p>
                        {/* react-text: 1461 */}I agree{/* /react-text */}
                        <span
                          onClick={() => navigate("/terms")}
                          style={{ color: "#38a6fb", marginLeft: "2px" }}
                          className="term-content"
                        >
                          Terms of use
                        </span>
                      </p>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className={`submit-btn ${
                      type == "login" ? "login-btn" : "register-btn"
                    }`}
                  >
                    {type == "login" ? t("LogIn") : t("Register")}
                  </button>
                  {type == "login" && (
                    <div className="social-media-login hide">
                      <div className="tips">
                        <span>or log in with</span>
                      </div>
                      <div className="item-group" />
                    </div>
                  )}
                  <div className="form_links">
                    {type == "login" ? (
                      t("Noaccountyet")
                    ) : (
                      <p>{t("Alreadyhaveanaccount")}</p>
                    )}
                    <Link
                      className="form_link reg"
                      to={`/auth/${type == "login" ? "register" : "login"}`}
                    >
                      {type == "login" ? t("Register") : t("Login")}
                    </Link>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
